import {
  MyLeadsSearchQuery,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';

export type AudiencePresetType = {
  key: string;
  keys: string[];
  name: string;
  searchQuery: MyLeadsSearchQuery;
};

export const useSuggestedAudiencesPresets = () => {
  const presets: AudiencePresetType[] = [
    {
      key: 'returningVisitors',
      keys: ['web_sessions_count'],
      name: 'Returning Visitors',
      searchQuery: {
        query: {
          attributes: {
            web_sessions_count: [{ gt: '2' }],
          },
        },
      },
    },
    {
      key: 'engagedUsers',
      keys: ['num_of_clicks', 'web_page_views'],
      name: 'Highest Engaged Users',
      searchQuery: {
        query: {
          attributes: {
            web_page_views: [{ gt: '2' }],
            num_of_clicks: [{ gt: '3' }],
          },
        },
      },
    },
    {
      key: 'klaviyoPurchase',
      keys: ['klaviyo_purchased'],
      name: 'Purchased via Klaviyo',
      searchQuery: {
        query: {
          attributes: {
            klaviyo_purchased: [true],
          },
        },
      },
    },
    {
      key: 'urlsVisited',
      keys: [SubsectionKeys.urlsVisited],
      name: 'Landed on Cart page',
      searchQuery: {
        query: {
          wildcardAttributes: { [SubsectionKeys.urlsVisited]: ['cart'] },
        },
      },
    },
  ];

  return { presets };
};
